import MessageFilePreviewModal from './MessageFilePreviewModal.component';

export default MessageFilePreviewModal;
